"use client";

import { SignIn } from "../signin-button";
import { useSubscribe } from "@deputy-ai/common/observable";
import { Dialog } from "@deputy-ai/ui/dialog/Dialog";
import { useState } from "react";
import { Subject } from "rxjs";

const open$ = new Subject<void>();

export function openSigninDialog() {
  open$.next();
}

export function SigninDialog() {
  const [isOpen, setIsOpen] = useState(false);

  useSubscribe(open$, () => {
    setIsOpen(true);
  }, []);

  return (
    <Dialog open={isOpen}>
      <Dialog.Content closeButton={false}>
        <Dialog.Header>
          <Dialog.Title>Sign in</Dialog.Title>
          <Dialog.Description>
            Sign in has expired. Please sign in again.
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer>
          <SignIn />
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
}
